
<div class="container-fluid">
  <div class="container">
  <div class="card text-center" style="width: 18rem;">
    <i class="bi bi-file-earmark-check-fill"></i>
    <!-- <img src="../../../../assets/images/process_comp.svg" class="card-img-top" alt="..."> -->
    <div class="card-body">
      <p class="card-text"><b>Synthetic Test Data Generation Successful!</b></p>
      <p>You will be automatically redirected to Home Page in {{ seconds }}</p>
    </div>

  </div>
</div>

</div>
